/* Puff Land – script chargé par les sections concernées (dépend de theme.js) */
(() => {
  'use strict';
  const PL = window.PL;
  if (!PL || !PL.u || PL.loaded_hero) return;
  PL.loaded_hero = true;
  const { $, $$, debounce, parseHTML, storage, formatMoney, toast, trapFocus, esc, norm, num, fill, fetchProductData, productDataUrl, productBase, starsHTML, buyButton, isDesktop, reduceMotion, initWishlistButtons, applyDiscountCode, getCart, refreshCart } = PL.u;
  const S = PL.strings;
  const R = PL.routes;
  const Cart = PL.cart;
  const Compare = PL.compare;

  /* ---------- Héro (slider) ---------- */
  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.hero__slide, [data-slide]', this);
      this.dots = $$('[data-hero-dot]', this);
      this.index = 0;
      if (this.slides.length < 2) return;
      this.delay = (parseInt(this.dataset.speed, 10) || 6) * 1000;
      this.playing = this.dataset.autoplay === 'true' && !reduceMotion;
      this.dots.forEach((d) => d.addEventListener('click', () => { this.show(Number(d.dataset.heroDot)); this.restart(); }));
      const prev = $('[data-hero-prev]', this);
      const next = $('[data-hero-next]', this);
      if (prev) prev.addEventListener('click', () => { this.show(this.index - 1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.show(this.index + 1); this.restart(); });
      this.pauseBtn = $('[data-hero-pause]', this);
      if (this.pauseBtn) {
        if (!this.playing) this.pauseBtn.hidden = true;
        this.pauseBtn.addEventListener('click', () => {
          this.playing = !this.playing;
          this.pauseBtn.setAttribute('aria-pressed', this.playing ? 'false' : 'true');
          this.restart();
        });
      }
      let x0 = null;
      this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { this.show(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
        x0 = null;
      });
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => this.restart());
      this.addEventListener('focusin', () => clearInterval(this.timer));
      this.restart();
      // Deuxième bannière chargée une fois la page prête (première bannière déjà prioritaire)
      window.addEventListener('load', () => { const img = $('img[loading="lazy"]', this.slides[1]); if (img) img.loading = 'eager'; }, { once: true });
    }
    show(i) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.slides.forEach((s, k) => {
        const on = k === this.index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        $$('a, button', s).forEach((el) => { el.tabIndex = on ? 0 : -1; });
      });
      this.dots.forEach((d, k) => { d.classList.toggle('is-active', k === this.index); if (k === this.index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      // Image affichée et suivante chargées d'avance : pas de bannière vide pendant le fondu
      [this.index, (this.index + 1) % n].forEach((k) => { const img = $('img[loading="lazy"]', this.slides[k]); if (img) img.loading = 'eager'; });
    }
    restart() {
      clearInterval(this.timer);
      if (this.playing) this.timer = setInterval(() => this.show(this.index + 1), this.delay);
    }
  }
  if (!customElements.get('hero-slider')) customElements.define('hero-slider', HeroSlider);
})();
